<template>
  <div class="search_location">
    <!-- top row with btns -->
    <div class="first-row">
      <i @click="$router.go(-1)" class="material-icons clear-icon">clear</i>

      <div class="clear-btn pointer" @click="clearSearch()">Clear</div>
    </div>
    <!-- top row with btns -->

    <!-- search index row -->
    <div class="search-container">
      <select
        @change="query_location,goToRoute($store.state.search_loc.query_location)"
        v-model="$store.state.search_loc.query_location"
        class="search-location-dropdown"
        data-dropup-auto="false"
      >
        <option value="" disabled selected hidden>Worldwide</option>
        <option>Worldwide</option>
        <option>Barcelona</option>
        <option>Berlin</option>
        <option>Copenhagen (København)</option>
        <option>Florence (Firenze)</option>
        <option>Lisbon (Lisboa)</option>
        <option>London</option>
        <option>Los Angeles</option>
        <option>Madrid</option>
        <option>Milan (Milano)</option>
        <option>New York</option>
        <option>Paris</option>
        <option>Porto</option>
        <option>Rome (Roma)</option>
        <option>San Francisco</option>
      </select>
      <!-- <input
        @keyup="query_location"
        placeholder="Search Location..."
        v-model="$store.state.search_loc.query_location"
      />-->
    </div>
    <!-- /search index row -->

    <!-- db location -->
    <!-- <div class="result-locations-container"> -->
    <!-- <div
        v-for="(loc, i) in queried_locations"
        class="each-location pointer"
        @click="saveLocToLs(loc); goToRoute(loc.name)"
      >
    <div class="each-location-container">-->
    <!-- _left -->
    <!-- <div class="_left">
            <div class="icon-container">
              <i class="material-icons">location_on</i>
            </div>
            <div class="location-name">{{loc.name}}</div>
    </div>-->
    <!-- /_left -->
    <!-- _right -->
    <!-- <div class="_right">({{loc.pic_cnt}})</div> -->
    <!-- /_right -->
    <!-- </div>
      </div>
    </div>-->
    <!-- /db location -->

    <!-- recent ls location -->
    <!-- <div class="result-locations-container">
      <div @click="goToRoute(loc.name)" v-for="(loc, i) in lsLocs" class="each-location">
    <div class="each-location-container">-->
    <!-- _left -->
    <!-- <div class="_left">
            <div class="icon-container">
              <i class="material-icons">restore</i>
            </div>
            <div class="location-name">{{loc.name}}</div>
    </div>-->
    <!-- /_left -->
    <!-- _right -->
    <!-- <div class="_right" v-if="loc.name !== 'Worldwide'">({{loc.pic_cnt}})</div> -->
    <!-- /_right -->
    <!-- </div>
      </div>
    </div>-->
    <!-- /recent ls location -->

    <!-- more dest coming soon -->
    <div class="main-more-container">
      <div class="filter-header-container">
        <div class="div-1">Select a filter to limit results</div>
        <div class="div-2"></div>
      </div>
    </div>
    <!-- /more dest coming soon -->

    <!--div
      v-for="(loc, i) in queried_locations"
    >
      {{loc}}
      {{loc.name}}
    </div-->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
// import firebase from "firebase";

export default {
  data() {
    return {
      lsLocs: []
    };
  },
  async created() {
    /*this.$store.commit('query_location', {
        //empty
      })*/
    //
    this.lsLocs = this.getLocsFromLs();
    this.clearSearch();
    //
    // testing token ;))
    /* let currentUser = await firebase.auth().currentUser
      if (currentUser) {
        let token = await currentUser.getIdToken(true)
        console.log({ token })
      }
      else {
        console.log('YOU ARE NOT LOGGED IN !')
      } */
    // testing token ;))
    //
  },
  computed: {
    ...mapGetters(["queried_locations"])
  },
  methods: {
    ...mapMutations(["query_location"]),
    //
    goToRoute(selected) {
      localStorage.removeItem("homePageImages");
      let obj = Object.assign({}, this.$route.query);
      obj.loc = selected;
      // console.log({ obj });
      let _from = localStorage.getItem("from");
      if (_from === "Map") {
        this.$router.push({ path: `/map`, query: obj });
      } else {
        let _mode = localStorage.getItem("Mode");
        this.$store.state.common.isModeSwipe =
          _mode === null ? false : JSON.parse(_mode);
        this.$router.push({ path: `/`, query: obj });
      }
    },
    //
    clearSearch() {
      this.$store.state.search_loc.query_location = "";
      this.$store.state.search_loc.queried_locations = [];
    },
    //
    getLocsFromLs() {
      // get locs from ls
      let lsLocs = localStorage.getItem("searchedLocs");
      let lsLocs2 = [];
      if (lsLocs) {
        lsLocs2 = JSON.parse(lsLocs);
      } else {
        lsLocs2 = [];
      }
      lsLocs2.unshift({ name: "Worldwide", bold: false, pic_cnt: -1 });
      return lsLocs2;
      // /get locs from ls
    },
    //
    saveLocToLs(newLoc) {
      // console.log({ saveLocToLs: newLoc });
      // check in ls, if loc exist, to avoid duplication
      let lsLocs = localStorage.getItem("searchedLocs");
      let alreadyExists = false;
      if (lsLocs) {
        lsLocs = JSON.parse(lsLocs);
        for (let i in lsLocs) {
          if (lsLocs[i].name === newLoc.name) {
            alreadyExists = true;
          }
        }
      }
      // check if it's worldwide
      let isWorldwide = false;
      if (newLoc.name === "Worldwide") {
        isWorldwide = true;
      }
      //
      //
      // console.log({ alreadyExists, isWorldwide });
      if (!alreadyExists && !isWorldwide) {
        if (!lsLocs) {
          lsLocs = []; // first time
        }
        // console.log("SAVE IN LS");
        lsLocs.push(newLoc);
        localStorage.setItem("searchedLocs", JSON.stringify(lsLocs));
      } else {
        // console.log("NOT SAVE IN LS");
      }
    }
    //
  }
};
</script>

<style scoped lang="scss">
@import "../assets/scss/filter/search_location";
</style>



// WEBPACK FOOTER //
// search_locations.vue?3dd1155a